export default function lowerCaseFilter(value: string): string {
  return value.toLowerCase();
}
